import React, { Fragment } from "react";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import ErrorDisplay from "../../components/Error/ErrorDisplay";
import Spinner from "../../components/UI/Spinner/Spinner";
import classes from "./Manuals.module.scss";
import { Link } from "react-router-dom";
import Manual from "./Manual/Manual";
import { Helmet } from "react-helmet";
import Parser from "html-react-parser";
import Accordion from "../../hoc/Accordion/Accordion";
import ScrollContainer from "react-indiana-drag-scroll";
import { uuidv4 } from "./../../shared/utility";
import Checkbox from "@mui/material/Checkbox";
import T from "./../../hoc/Language/translate.js";
import Serial from "../../components/Serial/Serial";
import {
  AssemblySort,
  EnglishFirst,
  MaterialSort,
  ModelYear,
  OperatorPartsSort,
  OperatorSort,
  PartsSort,
} from "./SortFunction";
import { SubCatFilter } from "./SubCatFilter";
import { OptionTableFilter } from "./OptionTableFilter";
import SideBarAccordion from "./SideBarAccordion";
import ConditionalWrapper from "../../hoc/ConditionalWrapper/ConditionalWrapper";
import fuzzysort from "fuzzysort";
import { inMaintenanceMode } from './../../shared/utility';

let SearchTerm = "";
let SubSearch = "";
let SortHigh = [
    "Stealth Pro",
  "No-Till Drills",
  "Min-Till Drills",
  "Tillage",
  "Compact Drills",
  "Kubota by Great Plains",
  "Rotary Cutters",
  "Simba Products",
  "Cultivator Drills",
  "Planting Components",
  "Planters",
  "Precision Seeding",
  "Sprayers",
  "Fertilizer Applicators",
  "Hitches",
  "Tillage Attachments",
];
let SortLow = ["Options", "Vintage Options"];
let SortMiddle = ["Vintage Tillage", "Vintage Drills", "Vintage Planters"];

class Manuals extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      value: "",
      lastSearch: "",
      filteredFuse: [],
      visible: 10,
      sort: "file_name",
      subFilter: "",
      Fam: "",
      helmet: "Product Manuals | Great Plains Ag",
      isNarrowingDown: false,
      DropDownFilter: "",
    };
    this.input = React.createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.loadMore = this.loadMore.bind(this);
    this.GetLabel = this.GetLabel.bind(this);
    this.setFilter = this.setFilter.bind(this);
    this.ResetFilter = this.ResetFilter.bind(this);
    this.setFam = this.setFam.bind(this);
  }

  async componentDidMount() {

    // changeUrlToFullPath(this.props);
    SearchTerm = this.props.match.params.query;
    await this.props.onFetchManuals(this.props.origin.language);
  }

  componentWillUpdate(nextProps, nextState, nextContext) {
    if (
      !this.props.origin.loading &&
      this.props.match.params.nid != undefined &&
      this.props.match.params.nid != 2402 &&
      nextProps.match.params.nid != undefined &&
      nextProps.match.params.nid != 2402 &&
      nextProps.origin.nodeMap[nextProps.match.params.nid].title != undefined &&
      this.props.origin.nodeMap[nextProps.match.params.nid].title !=
        undefined &&
      this.props.match.params.nid != nextProps.match.params.nid
    ) {
      // this.setState({
      //   helmet: `${
      //     this.props.origin.nodeMap[nextProps.match.params.nid].title !=
      //     undefined
      //       ? this.props.origin.nodeMap[nextProps.match.params.nid].title
      //       : "Product Manuals"
      //   } | Great Plains Ag`,
      // });
    }
  }
  async componentWillUnmount() {
    this.props.onClearManuals();
  }

  handleSubmit(event, props) {
    event.preventDefault();
    SearchTerm = this.input.current.value;
    SubSearch = this.state.DropDownFilter;
    this.setState({ value: this.input.current.value });
    let replacementString = `/${
      props.origin.language
    }/manuals/search/${encodeURIComponent(SearchTerm)}/${encodeURIComponent(
      SubSearch
    )}`;
    props.history.push(replacementString);
  }

  handleReset(props) {
    this.setState({
      subFilter: "",
      Fam: "",
      isNarrowingDown: false,
      DropDownFilter: "",
      value: "",
    });
    // this.state.value = "";
    this.props.match.params.query = "";
    let replacementString = `/${props.origin.language}/manuals/905`;
    props.history.push(replacementString);
  }

  setFilter(data) {
    //Sets the sub filter state used in the sidebar
    this.setState({ subFilter: data, Fam: "" });
  }
  setFam(data) {
    this.setState({ Fam: data, subFilter: "" });
  }
  ResetFilter() {
    //Resets the sub filter state if you click on anything else
    this.setState({
      subFilter: "",
      Fam: "",
      isNarrowingDown: false,
      DropDownFilter: "",
      value: "",
    });
  }

  loadMore() {
    //set the state to prev state and add 4 more
    // will load 4 more news each time its called
    this.setState((prev) => {
      return { visible: prev.visible + 4 };
    });
  }

  GetLabel(Fam, Page) {
    switch (Fam) {
      case undefined:
        return null;
        break;
      case "No-Till Drills":
        const Mapped = new Set([]);
        this.props.manuals.manuals[Fam].map(function (data, index) {
          data.field_no_till_drill_subcategorie.map(function (x, z) {
            Mapped.add(x);
          });
        });

        return (
          <div>
            <Link to={`/${this.props.origin.language}/manuals/${Page}`}>
              <div
                className={`${classes.Label} Label`}
                onClick={() => this.setFam(Fam)}
              >
                <Checkbox
                  className={classes.CheckBox}
                  checked={
                    (event != undefined && event.target.value == Fam) ||
                    Fam == this.state.Fam
                      ? true
                      : false
                  }
                  size={"small"}
                  value={Fam}
                  onClick={() => {
                    this.ResetFilter();
                  }}
                  style={{
                    color: "#e99617",
                  }}
                />

                {`All ${Fam}`}
              </div>
            </Link>

            {[...Mapped].map(
              function (data, index) {
                return (
                  <Link
                    to={`/${this.props.origin.language}/manuals/${Page}`}
                    key={uuidv4()}
                  >
                    <div
                      className={`${classes.Label} Label`}
                      key={uuidv4()}
                      onClick={() => this.setFilter(data)}
                    >
                      {/*<Link to={`/${this.props.origin.language}/manuals/${Page}`}>*/}
                      <Checkbox
                        checked={
                          (event != undefined &&
                            data != undefined &&
                            event.target.value == data) ||
                          data == this.state.subFilter
                            ? true
                            : false
                        }
                        size={"small"}
                        onClick={() => this.setFilter(data)}
                        value={data}
                        style={{
                          color: "#e99617",
                        }}
                      />
                      {/*</Link>*/}
                      {data}
                    </div>
                  </Link>
                );
              }.bind(this)
            )}
          </div>
        );
        break;

      case "Min-Till Drills":
        const MinMapped = new Set([]);
        this.props.manuals.manuals[Fam].map(function (data, index) {
          data.field_min_till_drill_subcategory.map(function (x, z) {
            MinMapped.add(x);
          });
        });

        return (
          <div>
            <Link to={`/${this.props.origin.language}/manuals/${Page}`}>
              <div
                className={`${classes.Label} Label`}
                onClick={() => this.setFam(Fam)}
              >
                <Checkbox
                  className={classes.CheckBox}
                  checked={
                    (event != undefined && event.target.value == Fam) ||
                    Fam == this.state.Fam
                      ? true
                      : false
                  }
                  size={"small"}
                  value={Fam}
                  onClick={() => {
                    this.ResetFilter();
                  }}
                  style={{
                    color: "#e99617",
                  }}
                />

                {`All ${Fam}`}
              </div>
            </Link>
            {[...MinMapped].map(
              function (data, index) {
                return (
                  <Link
                    to={`/${this.props.origin.language}/manuals/${Page}`}
                    key={uuidv4()}
                  >
                    <div
                      className={`${classes.Label} Label`}
                      key={uuidv4()}
                      onClick={() => this.setFilter(data)}
                    >
                      {/*<Link to={`/${this.props.origin.language}/manuals/${Page}`}>*/}
                      <Checkbox
                        checked={
                          (event != undefined &&
                            data != undefined &&
                            event.target.value == data) ||
                          data == this.state.subFilter
                            ? true
                            : false
                        }
                        size={"small"}
                        onClick={() => this.setFilter(data)}
                        value={data}
                        style={{
                          color: "#e99617",
                        }}
                      />
                      {/*</Link>*/}
                      {data}
                    </div>
                  </Link>
                );
              }.bind(this)
            )}
          </div>
        );
        break;

      case "Sprayers":
        const SprayMapped = new Set([]);
        this.props.manuals.manuals[Fam].map(function (data, index) {
          data.field_sprayer_subcategories.map(function (x, z) {
            SprayMapped.add(x);
          });
        });
        SprayMapped.delete("Sprayers");
        return (
          <div>
            <Link to={`/${this.props.origin.language}/manuals/${Page}`}>
              <div
                className={`${classes.Label} Label`}
                onClick={() => this.setFam(Fam)}
              >
                <Checkbox
                  className={classes.CheckBox}
                  checked={
                    (event != undefined && event.target.value == Fam) ||
                    Fam == this.state.Fam
                      ? true
                      : false
                  }
                  size={"small"}
                  value={Fam}
                  onClick={() => {
                    this.ResetFilter();
                  }}
                  style={{
                    color: "#e99617",
                  }}
                />

                {`All ${Fam}`}
              </div>
            </Link>

            {[...SprayMapped].map(
              function (data, index) {
                return (
                  <Link
                    to={`/${this.props.origin.language}/manuals/${Page}`}
                    key={uuidv4()}
                  >
                    <div
                      className={`${classes.Label} Label`}
                      key={uuidv4()}
                      onClick={() => this.setFilter(data)}
                    >
                      {/*<Link to={`/${this.props.origin.language}/manuals/${Page}`}>*/}
                      <Checkbox
                        checked={
                          (event != undefined &&
                            data != undefined &&
                            event.target.value == data) ||
                          data == this.state.subFilter
                            ? true
                            : false
                        }
                        size={"small"}
                        onClick={() => this.setFilter(data)}
                        value={data}
                        style={{
                          color: "#e99617",
                        }}
                      />
                      {/*</Link>*/}
                      {data}
                    </div>
                  </Link>
                );
              }.bind(this)
            )}
          </div>
        );
        break;
      case "Planters":
        const PlanterMapped = new Set([]);
        this.props.manuals.manuals[Fam].map(function (data, index) {
          data.field_planters_subcategories.map(function (x, z) {
            PlanterMapped.add(x);
          });
        });
        PlanterMapped.delete("Planters");
        return (
          <div>
            <Link to={`/${this.props.origin.language}/manuals/${Page}`}>
              <div
                className={`${classes.Label} Label`}
                onClick={() => this.setFam(Fam)}
              >
                <Checkbox
                  className={classes.CheckBox}
                  checked={
                    (event != undefined && event.target.value == Fam) ||
                    Fam == this.state.Fam
                      ? true
                      : false
                  }
                  size={"small"}
                  value={Fam}
                  onClick={() => {
                    this.ResetFilter();
                  }}
                  style={{
                    color: "#e99617",
                  }}
                />

                {`All ${Fam}`}
              </div>
            </Link>

            {[...PlanterMapped].map(
              function (data, index) {
                return (
                  <Link
                    to={`/${this.props.origin.language}/manuals/${Page}`}
                    key={uuidv4()}
                  >
                    <div
                      className={`${classes.Label} Label`}
                      key={uuidv4()}
                      onClick={() => this.setFilter(data)}
                    >
                      {/*<Link to={`/${this.props.origin.language}/manuals/${Page}`}>*/}
                      <Checkbox
                        checked={
                          (event != undefined &&
                            data != undefined &&
                            event.target.value == data) ||
                          data == this.state.subFilter
                            ? true
                            : false
                        }
                        size={"small"}
                        onClick={() => this.setFilter(data)}
                        value={data}
                        style={{
                          color: "#e99617",
                        }}
                      />
                      {/*</Link>*/}
                      {data}
                    </div>
                  </Link>
                );
              }.bind(this)
            )}
          </div>
        );
        break;

      case "Precision Seeding":
        const SeedMapped = new Set([]);
        this.props.manuals.manuals[Fam].map(function (data, index) {
          data.field_precision_seeding_subcateg.map(function (x, z) {
            SeedMapped.add(x);
          });
        });

        return (
          <div>
            <Link to={`/${this.props.origin.language}/manuals/${Page}`}>
              <div
                className={`${classes.Label} Label`}
                onClick={() => this.setFam(Fam)}
              >
                <Checkbox
                  className={classes.CheckBox}
                  checked={
                    (event != undefined && event.target.value == Fam) ||
                    Fam == this.state.Fam
                      ? true
                      : false
                  }
                  size={"small"}
                  value={Fam}
                  onClick={() => {
                    this.ResetFilter();
                  }}
                  style={{
                    color: "#e99617",
                  }}
                />

                {`All ${Fam}`}
              </div>
            </Link>
            {[...SeedMapped].map(
              function (data, index) {
                return (
                  <Link
                    to={`/${this.props.origin.language}/manuals/${Page}`}
                    key={uuidv4()}
                  >
                    <div
                      className={`${classes.Label} Label`}
                      key={uuidv4()}
                      onClick={() => this.setFilter(data)}
                    >
                      {/*<Link to={`/${this.props.origin.language}/manuals/${Page}`}>*/}
                      <Checkbox
                        checked={
                          (event != undefined &&
                            data != undefined &&
                            event.target.value == data) ||
                          data == this.state.subFilter
                            ? true
                            : false
                        }
                        size={"small"}
                        onClick={() => this.setFilter(data)}
                        value={data}
                        style={{
                          color: "#e99617",
                        }}
                      />
                      {/*</Link>*/}
                      {data}
                    </div>
                  </Link>
                );
              }.bind(this)
            )}{" "}
          </div>
        );
        break;
      case "Tillage Attachments":
        const TillageAttachmentsMapped = new Set([]);
        this.props.manuals.manuals[Fam].map(function (data, index) {
          data.field_tillage_attachment_subcate.map(function (x, z) {
            TillageAttachmentsMapped.add(x);
          });
        });

        return (
          <div>
            <Link to={`/${this.props.origin.language}/manuals/${Page}`}>
              <div
                className={`${classes.Label} Label`}
                onClick={() => this.setFam(Fam)}
              >
                <Checkbox
                  className={classes.CheckBox}
                  checked={
                    (event != undefined && event.target.value == Fam) ||
                    Fam == this.state.Fam
                      ? true
                      : false
                  }
                  size={"small"}
                  value={Fam}
                  onClick={() => {
                    this.ResetFilter();
                  }}
                  style={{
                    color: "#e99617",
                  }}
                />

                {`All ${Fam}`}
              </div>
            </Link>

            {[...TillageAttachmentsMapped].map(
              function (data, index) {
                return (
                  <Link
                    to={`/${this.props.origin.language}/manuals/${Page}`}
                    key={uuidv4()}
                  >
                    <div
                      className={`${classes.Label} Label`}
                      key={uuidv4()}
                      onClick={() => this.setFilter(data)}
                    >
                      {/*<Link to={`/${this.props.origin.language}/manuals/${Page}`}>*/}
                      <Checkbox
                        checked={
                          (event != undefined &&
                            data != undefined &&
                            event.target.value == data) ||
                          data == this.state.subFilter
                            ? true
                            : false
                        }
                        size={"small"}
                        onClick={() => this.setFilter(data)}
                        value={data}
                        style={{
                          color: "#e99617",
                        }}
                      />
                      {/*</Link>*/}
                      {`${data.slice(0, 30)}...`}
                    </div>
                  </Link>
                );
              }.bind(this)
            )}
          </div>
        );
        break;
      case "Tillage":
        const TillageMapped = new Set([]);
        this.props.manuals.manuals[Fam].map(function (data, index) {
          data.field_tillage_subcategories.map(function (x, z) {
            TillageMapped.add(x);
          });
        });

        return (
          <div>
            <Link to={`/${this.props.origin.language}/manuals/${Page}`}>
              <div
                className={`${classes.Label} Label`}
                onClick={() => this.setFam(Fam)}
              >
                <Checkbox
                  className={classes.CheckBox}
                  checked={
                    (event != undefined && event.target.value == Fam) ||
                    Fam == this.state.Fam
                      ? true
                      : false
                  }
                  size={"small"}
                  value={Fam}
                  onClick={() => {
                    this.ResetFilter();
                  }}
                  style={{
                    color: "#e99617",
                  }}
                />

                {`All ${Fam}`}
              </div>
            </Link>

            {[...TillageMapped].map(
              function (data, index) {
                return (
                  <Link
                    className={`${classes.Link} Link`}
                    to={`/${this.props.origin.language}/manuals/${Page}`}
                    key={uuidv4()}
                  >
                    <div
                      className={`${classes.Label} Label`}
                      key={uuidv4()}
                      onClick={() => this.setFilter(data)}
                    >
                      {/*<Link to={`/${this.props.origin.language}/manuals/${Page}`}>*/}
                      <Checkbox
                        checked={
                          (event != undefined &&
                            data != undefined &&
                            event.target.value == data) ||
                          data == this.state.subFilter
                            ? true
                            : false
                        }
                        size={"small"}
                        onClick={() => this.setFilter(data)}
                        value={data}
                        style={{
                          color: "#e99617",
                        }}
                      />
                      {/*</Link>*/}
                      {`${data.slice(0, 30)}...`}
                    </div>
                  </Link>
                );
              }.bind(this)
            )}
          </div>
        );
        break;
      default:
        return null;
    }
  }

  getManualItems = (manualList, index, boolean) => {

    let standardManuals =
      manualList.manual_files &&
      Object.keys(manualList.manual_files).filter(
        (fileKey) =>
          !manualList.manual_files[fileKey].field_manual_type_final.includes(
            "Start"
          ) &&
          !manualList.manual_files[fileKey].field_manual_type_final.includes(
            "Service"
          ) &&
          !manualList.manual_files[fileKey].field_manual_type_final.includes(
            "EZEE"
          ) &&
          !manualList.manual_files[fileKey].field_manual_type_final.includes(
            "Adjustment"
          )
      );

    let fieldAdjustment;
    if (manualList.field_adjustement !== undefined) {
      fieldAdjustment =
        manualList.field_adjustement &&
        Object.values(manualList.field_adjustement).filter(
          (fileKey) => fileKey !== true
        );
    }

    let service =
      manualList.manual_files &&
      Object.keys(manualList.manual_files).filter((fileKey) =>
        manualList.manual_files[fileKey].field_manual_type_final.includes(
          "Service"
        )
      );

    let StartGuide =
      manualList.manual_files &&
      Object.keys(manualList.manual_files).filter((fileKey) =>
        manualList.manual_files[fileKey].field_manual_type_final.includes(
          "Start"
        )
      );
    let Ezee =
      manualList.manual_files &&
      Object.keys(manualList.manual_files).filter((fileKey) =>
        manualList.manual_files[fileKey].field_manual_type_final.includes(
          "EZEE Guide"
        )
      );
    let RelatedProducts =
      manualList.field_relevant_product_page &&
      manualList.field_relevant_product_page.filter(
        (data) => this.props.origin.nodeMap[data]
      );

    let AUTH = this.props.auth.auth;

    // let Notes = Object.entries(manualList.notes).fitler((data) => data.length);
    // console.log(manualList.notes);
    //filter is on here because the relevant product page returns NID that dont belong to anything throwing errors

    return (
      <ConditionalWrapper
        condition={this.props.auth.auth}
        wrapper={(children) => (
          <div className={"HoverOver"}>
            <a
              className={"EditThisLink"}
              href={`https://cms.greatplainsag.gpmfg.io/${this.props.origin.language}/node/${manualList.nid}/edit`}
              target="_blank"
            >
              Edit This Content
            </a>
            {children}
          </div>
        )}
        key={uuidv4()}
      >
        <div className={`${classes.ManualSet} ManualSet`} key={uuidv4()}>
          {manualList.title != undefined ? (
            <h3 className={`${classes.SetTitle} SetTitle`}>
              {Parser(manualList.title)}
            </h3>
          ) : null}

          {standardManuals !== undefined && standardManuals.length > 0 ? (
            <div className={`${classes.ManualSubset} ManualSubset`}>
              <Accordion
                open={true}
                title={T("Standard Manuals", this.props.origin.language)}
                data={
                  <ul key={uuidv4()}>
                    {standardManuals
                      .sort((a, b) => ModelYear(a, b, manualList))
                      .sort((a, b) => EnglishFirst(a, b, manualList))
                      .sort((a, b) => AssemblySort(a, b, manualList))
                      .sort((a, b) => MaterialSort(a, b, manualList))
                      .sort((a, b) => PartsSort(a, b, manualList))
                      .sort((a, b) => OperatorPartsSort(a, b, manualList))
                      .sort((a, b) => OperatorSort(a, b, manualList))
                      .map((fileKey, index) => {
                        !manualList.manual_files[
                          fileKey
                        ].field_manual_type_final.includes("Service");

                        return (
                          <ConditionalWrapper
                            condition={this.props.auth.auth}
                            wrapper={(children) => (
                              <div className={"HoverOver Outline"}>
                                <a
                                  className={"EditThisLink "}
                                  target="_blank"
                                  href={`https://cms.greatplainsag.gpmfg.io/en/node/${manualList.manual_files[fileKey].nid}/edit`}
                                >
                                  Edit This Content
                                </a>
                                {children}
                              </div>
                            )}
                            key={uuidv4()}
                          >
                            <Manual
                              key={uuidv4()}
                              nid={manualList.nid}
                              manual={manualList.manual_files[fileKey]}
                            />
                          </ConditionalWrapper>
                        );
                      })}
                  </ul>
                }
              />
            </div>
          ) : null}

          {fieldAdjustment !== undefined && fieldAdjustment.length > 0 ? (
            <div className={`${classes.ManualSubset} ManualSubset`}>
              <Accordion
                title={T("Field Adjustment Guides", this.props.origin.language)}
                data={
                  <ul className={`styled triangle black`} key={uuidv4()}>
                    {fieldAdjustment.map(function (a, b) {
                      return (
                        <ConditionalWrapper
                          condition={AUTH}
                          wrapper={(children) => (
                            <div className={"HoverOver Outline"}>
                              <a
                                className={"EditThisLink "}
                                target="_blank"
                                href={`https://cms.greatplainsag.gpmfg.io/en/node/${a.nid}/edit`}
                              >
                                Edit This Content
                              </a>
                              {children}
                            </div>
                          )}
                          key={uuidv4()}
                        >
                          <li
                            className={`${classes.Wrapper} Wrapper`}
                            key={uuidv4()}
                          >
                            <a
                              href={a.field_field_adjustment_guide_fil}
                              key={uuidv4()}
                              className={"Link"}
                            >
                              {Parser(a.title)}
                            </a>
                          </li>
                        </ConditionalWrapper>
                      );
                    })}
                  </ul>
                }
              />
            </div>
          ) : null}
          {service !== undefined && service.length > 0 ? (
            <div className={`${classes.ManualSubset} ManualSubset`}>
              <Accordion
                title={T(
                  "Service Information and Monitor Manuals",
                  this.props.origin.language
                )}
                data={
                  <ul key={uuidv4()}>
                    {service

                      .sort(function (fileKey, fileKeyB) {
                        if (
                          manualList.manual_files[
                            fileKey
                          ].field_manual_language_final.includes("English")
                        ) {
                          return -1;
                        }
                        if (
                          manualList.manual_files[
                            fileKeyB
                          ].field_manual_language_final.includes("English")
                        ) {
                          return 1;
                        }

                        return 0;
                      })

                      .map((fileKey, index) => {
                        return (
                          <ConditionalWrapper
                            condition={AUTH}
                            wrapper={(children) => (
                              <div className={"HoverOver Outline"}>
                                <a
                                  className={"EditThisLink "}
                                  target="_blank"
                                  href={`https://cms.greatplainsag.gpmfg.io/en/node/${manualList.manual_files[fileKey].nid}/edit`}
                                >
                                  Edit This Content
                                </a>
                                {children}
                              </div>
                            )}
                            key={uuidv4()}
                          >
                            <Manual
                              key={manualList.manual_files[fileKey].nid}
                              nid={manualList.nid}
                              manual={manualList.manual_files[fileKey]}
                            />
                          </ConditionalWrapper>
                        );
                        // }
                      })}
                  </ul>
                }
              />
            </div>
          ) : null}

          {StartGuide !== undefined && StartGuide.length > 0 ? (
            <div>
              <Accordion
                title={T("Quick Start Guides", this.props.origin.language)}
                data={
                  <ul key={uuidv4()}>
                    {StartGuide.sort(function (fileKey, fileKeyB) {
                      if (
                        manualList.manual_files[
                          fileKey
                        ].field_manual_language_final.includes("English")
                      ) {
                        return 1;
                      }
                      if (
                        manualList.manual_files[
                          fileKeyB
                        ].field_manual_language_final.includes("English")
                      ) {
                        return -1;
                      }

                      return 0;
                    }).map((fileKey, index) => {
                      return (
                        <ConditionalWrapper
                          condition={AUTH}
                          wrapper={(children) => (
                            <div className={"HoverOver Outline"}>
                              <a
                                className={"EditThisLink "}
                                target="_blank"
                                href={`https://cms.greatplainsag.gpmfg.io/en/node/${manualList.manual_files[fileKey].nid}/edit`}
                              >
                                Edit This Content
                              </a>
                              {children}
                            </div>
                          )}
                          key={uuidv4()}
                        >
                          <Manual
                            key={manualList.manual_files[fileKey].nid}
                            nid={manualList.nid}
                            manual={manualList.manual_files[fileKey]}
                          />
                        </ConditionalWrapper>
                      );
                      // }
                    })}
                  </ul>
                }
              />
            </div>
          ) : null}

          {Ezee !== undefined && Ezee.length > 1 ? (
            <div className={`${classes.ManualSubset} ManualSubset`}>
              <Accordion
                title={T("EZEE Guides", this.props.origin.language)}
                data={
                  <ul key={uuidv4()}>
                    {Ezee.map((fileKey, index) => {
                      return (
                        <ConditionalWrapper
                          condition={AUTH}
                          wrapper={(children) => (
                            <div className={"HoverOver Outline"}>
                              <a
                                className={"EditThisLink "}
                                target="_blank"
                                href={`https://cms.greatplainsag.gpmfg.io/en/node/${manualList.manual_files[fileKey].nid}/edit`}
                              >
                                Edit This Content
                              </a>
                              {children}
                            </div>
                          )}
                          key={uuidv4()}
                        >
                          <Manual
                            key={manualList.manual_files[fileKey].nid}
                            nid={manualList.nid}
                            manual={manualList.manual_files[fileKey]}
                          />
                        </ConditionalWrapper>
                      );
                      // }
                    })}
                  </ul>
                }
              />
            </div>
          ) : null}
          {RelatedProducts && RelatedProducts.length ? (
            <div className={`${classes.ManualSubset} ManualSubset`}>
              <h6>{T("Related Product Pages", this.props.origin.language)}</h6>

              <ul className={`styled triangle black`} key={uuidv4()}>
                {RelatedProducts.map((data, index) => {
                  return (
                    <li key={uuidv4()}>
                      <Link
                        to={{
                          pathname: `/node/${data}`,
                        }}
                      >
                        {Parser(this.props.origin.nodeMap[data].title)}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
          ) : null}
          {manualList.notes && manualList.notes.length > 2 ? (
            <div className={`${classes.ManualSubset} ManualSubset`}>
              <h6>{T("Notes", this.props.origin.language)}</h6>
              <ul className={`styled triangle black`} key={uuidv4()}>
                {Parser(manualList.notes)}
              </ul>
            </div>
          ) : null}
          {manualList.field_product_manual_tags_keywor &&
          manualList.field_product_manual_tags_keywor.length > 1 ? (
            <div className={`${classes.ManualSubset} ManualSubset`}>
              <h6>
                {T("Keywords:", this.props.origin.language)}{" "}
                {Parser(
                  manualList.field_product_manual_tags_keywor.replaceAll(
                    ",",
                    ", "
                  )
                )}{" "}
              </h6>
            </div>
          ) : null}
        </div>
      </ConditionalWrapper>
    );
  };

  render() {
    //initialize the component in the loading state
    let content = <Spinner />;
    let origin = this.props.origin;
    let Lang = this.props.origin.language;
    let bodyText =
      this.props.manuals.manuals != undefined &&
      this.props.manuals.manuals.bodyText != undefined
        ? this.props.manuals.manuals.bodyText.body
        : null;

    if (!this.props.loading) {
      if (!this.props.error) {
          let manuals = this.props.manuals.manuals;
          let OptionsArray = [];
          let filter = this.state.sort;
          let subCat = this.state.subFilter;
          this.props.manuals.manuals.Options &&
            // console.log(this.props.manuals.manuals.Options);
            this.props.manuals.manuals.Options.map(function (data) {
              data.manual_files != undefined
                ? Object.entries(data.manual_files).map(function (
                    dataNested,
                    IndexNested
                  ) {
                    dataNested[1].title = data.title;
                    OptionsArray.push(dataNested[1]);
                  })
                : null;
            });
          let tempArray = [];
          let tempArrayV2 = [];

          let ToSearch = this.props.manuals.manualsSequential.map(function (
            data
          ) {
            if (
              data.field_product_manual_tags_keywor == undefined ||
              data.field_product_manual_tags_keywor.length == 0
            ) {
              data.field_product_manual_tags_keywor = " ";
            } else
              data.field_product_manual_tags_keywor =
                typeof data.field_product_manual_tags_keywor == "object"
                  ? data.field_product_manual_tags_keywor.join()
                  : data.field_product_manual_tags_keywor;

            if (
              data.field_notes_and_links == undefined ||
              data.field_notes_and_links.length == 0
            ) {
              data.field_notes_and_links = " ";
            } else
              data.field_notes_and_links =
                typeof data.field_notes_and_links == "object"
                  ? data.field_notes_and_links.join()
                  : data.field_notes_and_links;

            if (data.notes == undefined || data.notes.length == 0) {
              data.notes = " ";
            } else
              data.notes =
                typeof data.notes == "object" ? data.notes.join() : data.notes;

            return data;
          });

          if (this.props.match.params.query) {
            if (this.state.lastSearch != this.props.match.params.query) {
              let results = fuzzysort.go(
                decodeURIComponent(this.props.match.params.query),
                ToSearch,
                {
                  keys: [
                    "title",
                    "field_product_manual_tags_keywor",
                    "notes",
                    "field_notes_and_links",
                  ],
                  allowTypo: false,
                }
              );

              this.setState({
                filteredFuse: results,
                lastSearch: this.props.match.params.query,
              });
            }
          }

          Object.entries(this.props.manuals.manuals.listing)
            .filter((lisitng) => lisitng != undefined)
            // .filter((lisitng) => (lisitng.nm == "body" ? false : true))
            .map((data, index) => {
              if (
                data[0] != "11273" &&
                // data[0] != "10924" &&
                data[0] != "2402" &&
                data[0] != "1622" &&
                data[0] != "905"
              ) {
                tempArrayV2.push({
                  title: data[1],
                  nm: data[0],
                });
              }
            });

          Object.entries(this.props.manuals.manuals.listingEnglish)
            .filter((lisitng) => lisitng != undefined)
            .map((data, index) => {
              if (
                data[0] != "11273" &&
                // data[0] != "10924" &&
                data[0] != "2402" &&
                data[0] != "1622" &&
                data[0] != "905"
              ) {
                tempArray.push({
                  title: data[1],
                  nm: data[0],
                });
              }
            });

          let manualList = (
            <Fragment key={uuidv4()}>
              {tempArrayV2
                .sort(function (a, b) {
                  if (a.title < b.title) {
                    return -1;
                  }
                  if (a.title > b.title) {
                    return 1;
                  }
                  return 0;
                })
                .map((familyTitle, index) => {
                  return (
                    <Fragment key={uuidv4()}>
                      <li key={uuidv4()} onClick={this.ResetFilter}>
                        <Link
                          to={`/${this.props.origin.language}/manuals/${familyTitle.nm}`}
                        >
                          {familyTitle.title}
                        </Link>
                      </li>
                    </Fragment>
                  );
                })}
            </Fragment>
          );

          let manualListSideBar = (
            <div
              key={uuidv4()}
              // onClick={() => this.setState({ isActive: !this.state.isActive })}
            >
              {tempArrayV2
                .sort(function (a, b) {
                  if (a.title < b.title) {
                    return -1;
                  }
                  if (a.title > b.title) {
                    return 1;
                  }
                  return 0;
                })
                .map((familyTitle, index) => {
                  if (
                    this.GetLabel(familyTitle.title, familyTitle.nm) == null
                  ) {
                    return (
                      <Fragment key={uuidv4()}>
                        <li
                          key={uuidv4()}
                          onClick={this.ResetFilter}
                          className={classes.SideBarList}
                        >
                          <Link
                            to={`/${this.props.origin.language}/manuals/${familyTitle.nm}`}
                          >
                            {familyTitle.title}
                          </Link>
                        </li>
                      </Fragment>
                    );
                  } else {
                    return (
                      <Fragment key={uuidv4()}>
                        <SideBarAccordion
                          title={`${familyTitle.title}`}
                          family={familyTitle.nm}
                          lang={this.props.origin.language}
                          data2={this.GetLabel(
                            familyTitle.title,
                            familyTitle.nm
                          )}
                        />
                      </Fragment>
                    );
                  }
                })}
            </div>
          );

          let filteredManuals = null;
          let filteredOptions = null;
          let Auth = this.props.auth.auth;
          let OptionSet = this.props.manuals.Category;

          tempArray.forEach((familyTitle) => {
            // console.log(familyTitle);

            if (
              familyTitle.nm != undefined &&
              familyTitle.nm == this.props.match.url.split("/").pop()
            ) {
              //If the Family is Options (nm = 918) we make a special table to look at the manuals with, else it just returns that flashcard list of manuals
              if (familyTitle.nm != undefined && familyTitle.nm == 918) {
                //OptionTableFilter    .sort((a, b) => EnglishFirst(a, b, manualList))
                return (filteredOptions = OptionsArray.sort((a, b) =>
                  OptionTableFilter(a, b, filter)
                ).map(function (data, index) {
                  return (
                    <>
                      <tr key={uuidv4()}>
                        {Auth ? (
                          <td key={uuidv4()}>
                            <a
                              className={"EditThisLink"}
                              href={`https://cms.greatplainsag.gpmfg.io/${Lang}/node/${data.nid}/edit`}
                              target="_blank"
                            >
                              Edit This Content
                            </a>
                          </td>
                        ) : null}
                        <td key={uuidv4()}>
                          <a href={data.manual_link} key={uuidv4()}>
                            {data.file_name}
                          </a>
                        </td>
                        <td key={uuidv4()}>{data.title}</td>
                        {/*<td key={uuidv4()}>*/}
                        {/*  {data.field_related_manual_set != undefined &&*/}
                        {/*  data.field_related_manual_set.length != 0 &&*/}
                        {/*  origin.nodeMap[data.field_related_manual_set] !=*/}
                        {/*    undefined &&*/}
                        {/*  origin.nodeMap[data.field_related_manual_set].title*/}
                        {/*    .length != 0*/}
                        {/*    ? Parser(*/}
                        {/*        origin.nodeMap[data.field_related_manual_set]*/}
                        {/*          .title*/}
                        {/*      )*/}
                        {/*    : null}*/}
                        {/*</td>*/}
                        <td key={uuidv4()}>
                          {data.field_manual_language_final}
                        </td>
                        <td key={uuidv4()}>
                          {/*Description*/}
                          {data.field_manual_description_final != undefined
                            ? data.field_manual_description_final
                            : null}
                        </td>
                        <td key={uuidv4()}>
                          {data.field_model_year != undefined &&
                          data.field_model_year.length > 0
                            ? data.field_model_year
                            : null}
                        </td>
                      </tr>
                    </>
                  );
                }));
              } else
                filteredManuals = this.props.manuals.manuals[familyTitle.title]
                  .filter((data) => SubCatFilter(data, subCat))

                  .sort(function (a, b) {
                    return a.field_weight_value - b.field_weight_value;
                  })

                  .map((manualList, index) => {
                    return this.getManualItems(manualList, index, false);
                  });
            }
          });

          // @kyler, I'm doing the following iteration of the nidMap object to extract a title for the current category
          // of manuals in the title. I'm not sure if this is the best way to do this. Let's review.
          let categoryTitle = null;

          Object.values(tempArrayV2).map((nid, index) => {
            if (nid.nm == this.props.match.url.split("/").pop()) {
              Object.values(tempArrayV2).map((title, subIndex) => {
                subIndex == index
                  ? (categoryTitle = title.title)
                  : (categoryTitle = categoryTitle);
              });
            }
          });

          content = (
            <div id="ContentMainWrapper" className={`ContentMainWrapper`}>
              <div id="ContentHeader" className={`ContentHeader`}>
                {!categoryTitle &&
                this.props.match.params.query == undefined ? (
                  <h1>
                    {T("Product", this.props.origin.language)}{" "}
                    {T("Manuals", this.props.origin.language)}
                  </h1>
                ) : this.props.match.params.query != undefined &&
                  this.props.match.params.query.length > 0 ? (
                  <h1>{`${T(
                    "Current Search Term:",
                    this.props.origin.language
                  )} ${this.props.match.params.query}`}</h1>
                ) : (
                  <h1>
                    Product Manuals: {categoryTitle}{" "}
                    {this.state.subFilter ? (
                      <span>: {this.state.subFilter}</span>
                    ) : null}
                  </h1>
                )}
              </div>
              <div
                id="ColumnWrapper"
                className={`Wrapper ColumnWrapper`}
                key={"ColumnWrapper"}
              >
                <div
                  id="ContentColumn"
                  className={`MainWrapper ContentColumn`}
                  key={"ContentColumn"}
                >
                  <div
                    id="BodyContent"
                    className={`BodyContent`}
                    key={"BodyContent"}
                  >
                    {this.props.match.params.query ? (
                      <div>
                        {this.state.filteredFuse &&
                        this.state.filteredFuse.length ? (
                          this.state.filteredFuse
                            // .sort(function (a, b) {
                            //   return (
                            //     a.obj.field_weight_value -
                            //     b.obj.field_weight_value
                            //   );
                            // })
                            .sort(function (a, b) {
                              // SortHigh SortLow SortMiddle these are the arrays above, change them to change what sorts by what
                              if (
                                SortHigh.includes(
                                  a.obj.field_product_manual_main_catego[0]
                                ) &&
                                !SortHigh.includes(
                                  b.obj.field_product_manual_main_catego[0]
                                )
                              ) {
                                return -1;
                              }

                              if (
                                !SortHigh.includes(
                                  a.obj.field_product_manual_main_catego[0]
                                ) &&
                                SortHigh.includes(
                                  b.obj.field_product_manual_main_catego[0]
                                )
                              ) {
                                return 1;
                              }

                              if (
                                SortLow.includes(
                                  a.obj.field_product_manual_main_catego[0]
                                ) &&
                                !SortLow.includes(
                                  b.obj.field_product_manual_main_catego[0]
                                )
                              ) {
                                return 1;
                              }

                              if (
                                !SortLow.includes(
                                  a.obj.field_product_manual_main_catego[0]
                                ) &&
                                SortLow.includes(
                                  b.obj.field_product_manual_main_catego[0]
                                )
                              ) {
                                return -1;
                              }
                            })

                            .slice(0, this.state.visible)
                            .map((manual) => {
                              return this.getManualItems(manual.obj, null);
                            })
                        ) : (
                          //@todo
                          <div>
                            {T("No Search Results", this.props.origin.language)}
                          </div>
                        )}
                        {this.state.visible <
                          this.state.filteredFuse.length && (
                          <button
                            onClick={this.loadMore}
                            type="button"
                            className={classes.LoadMore}
                          >
                            {T("Load more results", this.props.origin.language)}
                          </button>
                        )}
                      </div>
                    ) : filteredManuals == null && filteredOptions == null ? (
                      <ConditionalWrapper
                        condition={this.props.auth.auth}
                        wrapper={(children) => (
                          <div className={"HoverOver"}>
                            <a
                              className={"EditThisLink"}
                              href={`https://cms.greatplainsag.gpmfg.io/${this.props.origin.language}/node/905/edit`}
                            >
                              Edit This Content
                            </a>
                            {children}
                          </div>
                        )}
                      >
                        <div className={`ManualsDefault`}>
                          {Parser(bodyText)}

                          <div className={`ManualList`}>
                            {/*filteredManuals != null ? filteredManuals : manualList*/}

                            <ul key={uuidv4()}>{manualList}</ul>
                          </div>
                        </div>
                      </ConditionalWrapper>
                    ) : (
                      <div
                        className={`${classes.FilteredManuals} FilteredManuals`}
                      >
                        {filteredOptions != null ? (
                          <div
                            className={`${classes.TableWrapper} TableWrapper`}
                            id={"container"}
                          >
                            <ScrollContainer hideScrollbars={false}>
                              <table className={classes.Table}>
                                <tbody>
                                  <tr>
                                    {Auth ? <th>Edit Links</th> : null}
                                    <th
                                      onClick={() =>
                                        this.state.sort == "file_nameDescending"
                                          ? this.setState({ sort: "file_name" })
                                          : this.setState({
                                              sort: "file_nameDescending",
                                            })
                                      }
                                    >
                                      <span
                                        className={`${classes.FilterSpan} FilterSpan`}
                                      >
                                        Option Manual
                                      </span>
                                      <span
                                        className={`${classes.Symbols} FilterSpan`}
                                      >
                                        &#8691;
                                      </span>
                                    </th>
                                    <th>Product Group</th>
                                    {/*<th>RELATED OPTION OR PRODUCT GROUP</th>*/}
                                    <th
                                      onClick={() =>
                                        this.state.sort == "Lang"
                                          ? this.setState({
                                              sort: "LangDescending",
                                            })
                                          : this.setState({ sort: "Lang" })
                                      }
                                    >
                                      <span
                                        className={`${classes.FilterSpan} FilterSpan`}
                                      >
                                        Manual Language
                                      </span>
                                      <span
                                        className={`${classes.Symbols} FilterSpan`}
                                      >
                                        &#8691;
                                      </span>
                                    </th>
                                    <th
                                      onClick={() =>
                                        this.state.sort == "description"
                                          ? this.setState({
                                              sort: "descriptionDescending",
                                            })
                                          : this.setState({
                                              sort: "description",
                                            })
                                      }
                                    >
                                      <span
                                        className={`${classes.FilterSpan} FilterSpan`}
                                      >
                                        DESCRIPTION
                                      </span>
                                      <span
                                        className={`${classes.Symbols} FilterSpan`}
                                      >
                                        &#8691;
                                      </span>
                                    </th>
                                    <th
                                      onClick={() =>
                                        this.state.sort == "Year"
                                          ? this.setState({
                                              sort: "YearDescending",
                                            })
                                          : this.setState({ sort: "Year" })
                                      }
                                    >
                                      {" "}
                                      <span
                                        className={`${classes.FilterSpan} FilterSpan`}
                                      >
                                        MODEL YEAR
                                      </span>
                                      <span
                                        className={`${classes.Symbols} FilterSpan`}
                                      >
                                        &#8691;
                                      </span>
                                    </th>
                                  </tr>

                                  {filteredOptions}
                                </tbody>
                              </table>
                            </ScrollContainer>
                          </div>
                        ) : (
                          <div>{filteredManuals}</div>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                <div
                  id="SidebarColumn"
                  className={`SidebarWrapper SidebarColumn`}
                >
                  <div className={classes.SearchBarWrapper} key={"SearchForm"}>
                    <form
                      onSubmit={(event) => {
                        this.handleSubmit(event, this.props);
                      }}
                      className={classes.Search}
                      key={"Form"}
                    >
                      <h3 className={classes.SearchHeader}>
                        <label htmlFor={"Search"}>
                          {T("Manuals", this.props.origin.language)}{" "}
                          {T("Search", this.props.origin.language)}
                        </label>
                      </h3>
                      <div className={classes.SearchBar}>
                        <input
                          name="Search"
                          id="Search"
                          type="text"
                          // placeholder={this.state.value}
                          ref={this.input}
                        />
                      </div>

                      <button type="submit" className={classes.SearchSubmit}>
                        {T("Search", this.props.origin.language)}
                      </button>
                      <button
                        type="button"
                        onClick={() => {
                          this.handleReset(this.props);
                        }}
                        className={classes.SearchSubmit}
                      >
                        {T("Reset", this.props.origin.language)}
                      </button>
                    </form>
                  </div>

                  {!inMaintenanceMode() && <Serial />}

                  {
                    <div className={`MenuLevelTwo`}>
                      <Link to="/en/manuals/905">
                        <h3>{T("Manuals", this.props.origin.language)}</h3>
                      </Link>
                      <ul key={uuidv4()}>{manualListSideBar}</ul>
                    </div>
                  }
                </div>
              </div>
            </div>
          );
      } else {
        // if error came from the fetch
        content = <ErrorDisplay />;
      }
    }

    return (
      <div>
        <Helmet>
          <title>{T(this.state.helmet, this.props.origin.language)}</title>
          <meta
            name="description"
            content={
              this.props.match.params.nid == undefined ||
              this.props.origin.loading
                ? "Product Manuals: Great Plains offers electronic parts and operator's manuals free of charge. We make every effort to give you the correct information, but we reserve the right to make changes at any time. Click the desired manual's product line. All manuals are provided in Adobe PDF format"
                : this.props.origin.nodeMap[this.props.match.params.nid].title +
                  " manuals, guides, related products and information."
            }
            id="mymetatag"
          />
          <meta
            name="Keyword"
            content={
              this.props.match.params.nid == undefined ||
              this.props.origin.loading
                ? "Product Manuals"
                : this.props.origin.nodeMap[this.props.match.params.nid].title +
                  " manuals, guides, related products and information."
            }
            id="mymetatag"
          />
          <link
            rel="canonical"
            href={`https://www.greatplainsag.com${this.props.location.pathname}`}
          />
        </Helmet>
        {content}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    origin: { ...state.origin },
    manuals: { ...state.manuals },
    loading: state.manuals.loading,
    searchString: state.products.searchString,
    auth: { ...state.auth },
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFetchManuals: (lang) => dispatch(actions.fetchManuals(lang)),
    onClearManuals: () => dispatch(actions.clearManuals()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Manuals);
